import Vue from "vue";

Vue.component("loading", {
	props: [ "loadingText" ],
	template: `
	<div>
      	<p class="text-muted pb-0">
        	<i class="fas fa-circle-notch fa-spin"></i> {{ loadingText }}
      	</p>
	</div>
	`
});